<div class="m-portlet">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text" i18n>ePosvet</h3>
            </div>
        </div>
    </div>
    <div class="m-portlet__body">
        @if (showLogo) {
            <div class="m-2 pb-4 d-flex justify-content-between flex-wrap">
                @if (bs()?.name) {
                    <common-business-subject-icon
                        [size]="50"
                        [onlyIcon]="false"
                        [setBsId]="bs()"
                        style="font-size: 20px; font-weight: bold"
                    ></common-business-subject-icon>
                }
                @if (
                    this.selectedTerm?.reservationType &&
                    this.selectedTerm?.originUrl !== 'G100_01' &&
                    this.selectedTerm?.originUrl !== 'G100_03' &&
                    this.selectedTerm?.originUrl !== 'LAIF' &&
                    this.selectedTerm?.reservationType !== 'WIDGET_VOUCHER' &&
                    this.selectedTerm?.reservationType !== 'ASISTENT'
                ) {
                    <common-hd-app-icon
                        [height]="50"
                        [width]="150"
                        [onlyIcon]="true"
                        [showLogo]="true"
                        [setApp]="this.selectedTerm?.reservationType"
                    ></common-hd-app-icon>
                }
                @if (this.selectedTerm?.originUrl === 'G100_01' || this.selectedTerm?.originUrl === 'G100_03') {
                    <img width="150px" src="../../../../assets/app/media/img/logos/MEDIFIT_Logo-01.svg" />
                }
                @if (this.selectedTerm?.originUrl === 'LAIF') {
                    <img height="50px" src="../../../../assets/app/media/img/logos/laif_black.svg" />
                }
                @if (selectedTerm?.start) {
                    <div class="float-right">
                        <span class="text-right">Termin obravnave:</span>
                        <br />
                        <b>{{ selectedTerm?.start | date: 'dd.MM.yyyy' }}</b>
                        ob
                        <b>{{ selectedTerm?.start | date: 'HH:mm' }}</b>
                    </div>
                }
            </div>
        }
        @if (bsInstructions() && isHDActive) {
            <div class="portlet-alert">
                <div [innerHTML]="bsInstructions()" style="max-height: 120px; overflow-y: scroll" class="m-alert alert alert-metal text-dark"></div>
            </div>
        }
        @if (!selectedTerm.phoneCall) {
            <section>
                @if (!connectionStatus) {
                    <div class="portlet-alert">
                        <div class="m-alert m-alert--icon alert alert-danger">
                            <div class="m-alert__icon">
                                <i class="la la-warning"></i>
                            </div>
                            <div class="m-alert__text">
                                Povezava s strežnikom je prekinjena!
                                <br />
                                Preverite vašo internetno povezavo.
                            </div>
                        </div>
                    </div>
                }
                @if (connectionStatus) {
                    @if (!canStartCall && canStartCallReason === 'after') {
                        @if (channelInfo && channelInfo.doctorStartTime && channelInfo.doctorStartTime) {
                            <div class="portlet-alert">
                                <div class="m-alert m-alert--icon alert alert-success">
                                    <div class="m-alert__icon">
                                        <i class="la la-check"></i>
                                    </div>
                                    <div class="m-alert__text">
                                        ePosvet je zaključen.
                                        <br />
                                        Trajanje klica:
                                        <strong>
                                            {{
                                                (channelInfo.doctorSessionLength < channelInfo.patientSessionLength
                                                    ? channelInfo.patientSessionLength
                                                    : channelInfo.doctorSessionLength
                                                ) | amDuration: 'seconds' : false
                                            }}
                                        </strong>
                                    </div>
                                </div>
                            </div>
                        } @else {
                            <div class="portlet-alert">
                                <div class="m-alert m-alert--icon alert alert-danger">
                                    <div class="m-alert__icon">
                                        <i class="la la-warning"></i>
                                    </div>
                                    <div class="m-alert__text">
                                        Termin za klic je potekel.
                                        <br />
                                        ePosvet ni bil opravljen!
                                    </div>
                                </div>
                            </div>
                        }
                    }
                    @if (canStartCallReason !== 'after') {
                        @if (callState === callStates.CALL_STARTED && selectedTerm.prereservationId === callChannelId) {
                            <div class="portlet-alert">
                                <div class="m-alert m-alert--icon alert alert-brand">
                                    <div class="m-alert__icon">
                                        <i class="la la-video-camera"></i>
                                    </div>
                                    <div class="m-alert__text">Aktiven klic</div>
                                </div>
                            </div>
                        }
                        @if (outsideCallInProgress) {
                            <div class="portlet-alert">
                                <div class="m-alert m-alert--icon alert alert-brand">
                                    <div class="m-alert__icon">
                                        <i class="la la-video-camera"></i>
                                    </div>
                                    <div class="m-alert__text">Klic že poteka z uporabnikom {{ outsideCallInProgress?.displayName }}</div>
                                </div>
                            </div>
                        }
                        @if (callState !== callStates.CALL_STARTED && !outsideCallInProgress) {
                            @if (canStartCall) {
                                <div class="portlet-alert">
                                    @if (
                                        !patientReady.status &&
                                        !patientReady.userData &&
                                        channelInfo &&
                                        channelInfo.doctorStartTime &&
                                        channelInfo.doctorStartTime
                                    ) {
                                        <div class="m-alert m-alert--icon alert alert-success">
                                            <div class="m-alert__icon">
                                                <i class="la la-check"></i>
                                            </div>
                                            <div class="m-alert__text">
                                                ePosvet je zaključen. Stranka ni več na voljo.
                                                <br />
                                                Trajanje klica:
                                                <strong>
                                                    {{
                                                        (channelInfo.doctorSessionLength < channelInfo.patientSessionLength
                                                            ? channelInfo.patientSessionLength
                                                            : channelInfo.doctorSessionLength
                                                        ) | amDuration: 'seconds' : false
                                                    }}
                                                </strong>
                                            </div>
                                        </div>
                                    }
                                    @if (
                                        !patientReady.status &&
                                        !patientReady.userData &&
                                        !(channelInfo && channelInfo.doctorStartTime && channelInfo.doctorStartTime)
                                    ) {
                                        <div class="m-alert m-alert--icon alert alert-warning text-dark">
                                            <div class="m-alert__icon">
                                                <i class="la la-warning"></i>
                                            </div>
                                            <div class="m-alert__text">Stranka še ni pripravljena na klic.</div>
                                        </div>
                                    }
                                    <ng-template #patientState>
                                        <ul class="list-unstyled mb-0">
                                            <li>
                                                <small>
                                                    @if (patientReady.userData.onTerm) {
                                                        <i class="la la-check text-success"></i>
                                                    }
                                                    @if (!patientReady.userData.onTerm) {
                                                        <i class="la la-remove text-warning"></i>
                                                    }
                                                    Stranka je prijavljena
                                                </small>
                                            </li>
                                            <li>
                                                <small>
                                                    @if (patientReady.userData.cameraReady) {
                                                        <i class="la la-check text-success"></i>
                                                    }
                                                    @if (!patientReady.userData.cameraReady && !patientReady.userData.cameraError) {
                                                        <i class="la la-remove text-warning"></i>
                                                    }
                                                    @if (patientReady.userData.cameraError) {
                                                        <i class="la la-exclamation-circle text-danger"></i>
                                                    }
                                                    Kamera
                                                </small>
                                            </li>
                                            <li>
                                                <small>
                                                    @if (patientReady.userData.microphoneReady) {
                                                        <i class="la la-check text-success"></i>
                                                    }
                                                    @if (!patientReady.userData.microphoneReady && !patientReady.userData.microphoneError) {
                                                        <i class="la la-remove text-warning"></i>
                                                    }
                                                    @if (patientReady.userData.microphoneError) {
                                                        <i class="la la-exclamation-circle text-danger"></i>
                                                    }
                                                    Mikrofon
                                                </small>
                                            </li>
                                            <li>
                                                <small>
                                                    @if (patientReady.userData.clientReady) {
                                                        <i class="la la-check text-success"></i>
                                                    }
                                                    @if (!patientReady.userData.clientReady) {
                                                        <i class="la la-remove text-warning"></i>
                                                    }
                                                    Začni klic
                                                </small>
                                            </li>
                                        </ul>
                                    </ng-template>
                                    @if (!patientReady.status && patientReady.userData) {
                                        <div class="m-alert alert alert-metal text-dark">
                                            <div class="m-alert__text">
                                                @if (channelInfo && channelInfo.doctorStartTime && channelInfo.doctorStartTime) {
                                                    ePosvet je že potekal.
                                                    <br />
                                                    Stranka ima še vedno odprto okno za klic.
                                                }
                                                @if (!(channelInfo && channelInfo.doctorStartTime && channelInfo.doctorStartTime)) {
                                                    Stranka se pripravlja na klic
                                                }
                                                <ng-container *ngTemplateOutlet="patientState"></ng-container>
                                            </div>
                                        </div>
                                    }
                                    @if (patientReady.status) {
                                        <div class="m-alert m-alert--icon alert alert-success">
                                            <div class="m-alert__icon">
                                                <i class="la la-check"></i>
                                            </div>
                                            <div class="m-alert__text">
                                                @if (channelInfo && channelInfo.doctorStartTime && channelInfo.doctorStartTime) {
                                                    ePosvet je že potekal.
                                                    <br />
                                                    <strong>Stranka je še vedno pripravljena na klic.</strong>
                                                    Klic lahko ponovno vzpostavite.
                                                }
                                                @if (!(channelInfo && channelInfo.doctorStartTime && channelInfo.doctorStartTime)) {
                                                    Stranka je pripravljena na klic
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        }
                    }
                }
                @if ((callState !== callStates.CALL_STARTED || selectedTerm.prereservationId !== callChannelId) && !outsideCallInProgress) {
                    @if (canStartCallReason) {
                        <div class="portlet-alert">
                            @if (canStartCallReason === 'before') {
                                <div class="m-alert m-alert--icon alert alert-info">
                                    <div class="m-alert__icon">
                                        <i class="la la-info-circle"></i>
                                    </div>
                                    <div class="m-alert__text">
                                        Klic lahko pričnete
                                        <strong>{{ selectedTerm.callStart | amRelative }}</strong>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                }
                <div class="mb-3">
                    Predviden začetek video klica:
                    <br />
                    <strong>{{ selectedTerm.start | amRelative }}</strong>
                </div>
                <div class="mb-3">
                    Predviden čas video klica:
                    <br />
                    <strong>{{ selectedTerm.duration | amDuration: 'minutes' : false }}</strong>
                </div>
            </section>
        }

        <!--! CHAT -->

        @if (showChat) {
            <div>
                <div class="portlet-alert mb-0">
                    <div class="m-alert alert alert-metal mb-0">
                        <div class="m-alert__text m--font-inverse-light">Klepet</div>
                    </div>
                </div>
                @if (selectedTerm) {
                    <div class="mf-telm-chat">
                        <telm-chat [termData]="selectedTerm"></telm-chat>
                    </div>
                }
            </div>
        }
        <!--! /CHAT -->
        @if (!selectedTerm.phoneCall) {
            @if (callState !== callStates.CALL_STARTED && !outsideCallInProgress && connectionStatus) {
                <div class="my-1">
                    <button (click)="initCall()" class="btn m-btn m-btn--pill btn-block btn-outline-success btn-block m-btn--icon">
                        Odpri okno za klic
                    </button>
                </div>
                <div class="my-1">
                    <a href="{{ testDeviceUrl }}" target="_blank" class="btn m-btn m-btn--pill btn-block btn-outline-accent btn-block m-btn--icon">
                        Preveri svoje nastavitve
                    </a>
                </div>
            }
            @if (displaySendEmailButton) {
                <div class="my-1">
                    <button (click)="resendEmail()" class="btn m-btn m-btn--pill btn-block btn-outline-accent btn-block m-btn--icon" i18n>
                        Ponovno pošlji povezavo
                    </button>
                </div>
            }
        }
        @if (selectedTerm.phoneCall) {
            <section class="h-100">
                <div class="pb-3">
                    <button (click)="makePhoneCall()" class="btn m-btn m-btn--pill btn-block btn-outline-success btn-block">
                        Pokliči:
                        {{ selectedTerm?.customer?.phone }}
                    </button>
                </div>
            </section>
        }
    </div>
</div>
